import { render } from "./EmpMsg.vue?vue&type=template&id=c9677418"
import script from "./EmpMsg.vue?vue&type=script&lang=js"
export * from "./EmpMsg.vue?vue&type=script&lang=js"

import "./EmpMsg.vue?vue&type=style&index=0&id=c9677418&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__